import { Controller } from "@hotwired/stimulus";
import { FetchRequest, post } from '@rails/request.js'

export default class extends Controller {
  static targets = ['input', 'results']

  async input() {
    if (this.inputTarget.value.length < 3) {
      return;
    }
    const response = await post(this.inputTarget.dataset.workExperienceUrl, { body: JSON.stringify({ query: this.inputTarget.value }) });
    if (response.ok) {
      const body = await response.text
      if (body === null || body === '') {
        return;
      }
      const parsedBody = JSON.parse(body);
      const list = this.resultsTarget;
      const listItemClass = this.resultsTarget.dataset.workExperienceListItemClass;
      list.innerHTML = '';
      parsedBody.forEach(function(element) {
        const listItem = document.createElement('li');
        listItem.textContent = element;
        listItem.className = listItemClass;
        listItem.dataset.action = 'click->work-experience#select';
        list.appendChild(listItem);
      });
    }
  }

  select(event) {
    this.inputTarget.value = event.target.textContent;
    this.resultsTarget.innerHTML = '';
  }

  blur() {
    this.resultsTarget.innerHTML = '';
  }
}
